import "../../../../assets/css/request_details.css";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Toolbar from "@mui/material/Toolbar";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import DoneIcon from "@mui/icons-material/Done";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import RemoveDoneIcon from "@mui/icons-material/RemoveDone";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import GetAppRoundedIcon from "@mui/icons-material/GetAppRounded";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import swal from "sweetalert";

import { Accordion } from "react-bootstrap";

import Loading_animation_view from "../../../loading_animation_view/loading_animation_view";
import { get_applicant_request_details } from "../../../../services/purchase_service";
import {
  get_order_productsInfos,
  download_order_file,
  requester_change_order_state,
  check_weither_ispossible_to_proceed
} from "../../../../services/for_allServices";
import Order_details_modal from "./order_details/order_details";
import View_refuse_reason from "../view_refuse_reason/view_refuse_reason";
import InnerStockDetails from "./inner_stock/inner_stock_details";
import Set_comment from "../set_comment/set_comment";
import Validation_history from "../validation_history/validation_history";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: 16,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

function Request_detail({ title, details }) {
  return (
    <div>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="accordion_header_content"> {title} </div>
          </Accordion.Header>
          <Accordion.Body>
            <div className="order_form_details_container">
              <div className="order_form_infos_container">
                <div className="order_form_infos_title">
                  {" "}
                  1 - Infos personnel
                </div>
                <Row className="mb-12">
                  <Form.Group className="col-6">
                    <label>Nom</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Nom *"
                      value={details.requester_lastName}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-6">
                    <label>Prénom</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Prénom *"
                      value={details.requester_firstName}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-6">
                    <label>Département</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Département *"
                      value={details.requester_departement}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-6"> </Form.Group>
                  <Form.Group className="col-6">
                    <label>Email</label>
                    <Form.Control
                      required
                      autoComplete
                      type="email"
                      placeholder="Email *"
                      value={details.requester_email}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-6">
                    <label>Numéro de téléphone</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Numéro de téléphone"
                      value={details.requester_phoneNumber}
                      readOnly
                    />
                  </Form.Group>
                </Row>
                <div className="order_form_infos_title">
                  2 - Infos de livraison
                </div>
                <Row className="mb-12">
                  <Form.Group className="col-6">
                    <label>Pays</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Pays*"
                      value={details.delivery_country}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-6">
                    <label>Ville</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Ville *"
                      value={details.delivery_city}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-6">
                    <label>Adresse</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Adresse *"
                      value={details.delivery_address}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-6">
                    <label>Code postal</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      placeholder="Code postal *"
                      value={details.delivery_postCode}
                      readOnly
                    />
                  </Form.Group>

                  <Form.Group className="col-6">
                    <label>Date de livraison souhaitée</label>
                    <Form.Control
                      type="date"
                      min={new Date().toISOString().split("T")[0]}
                      placeholder="Date de livraison souhaitée *"
                      value={details.delivery_supposedDate.split(" ")[0]}
                      readOnly
                    />
                  </Form.Group>
                </Row>
                <div className="order_form_infos_title">
                  3 - Autres informations
                </div>
                <Row className="mb-12">
                  <Form.Group className="col-md-12">
                    <label>Projet</label>
                    <Form.Control
                      required
                      autoComplete
                      type="text"
                      minRows={3}
                      placeholder="Projet *"
                      value={details.project}
                      readOnly
                    />
                  </Form.Group>
                  <Form.Group className="col-md-12">
                    <label>Imputation</label>
                    <Form.Control
                      required
                      autoComplete
                      as="textarea"
                      rows="3"
                      placeholder="Imputation *"
                      value={details.object}
                      readOnly
                    />
                  </Form.Group>
                </Row>
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

function state(request_state) {
  return (
    <>
      {request_state === null || request_state === "demander à être changée" ? (
        <Button variant="contained" className="status_waiting">
          {request_state ? request_state : "En cours"}
        </Button>
      ) : request_state === "refusée" ||
        request_state === "refus de validation" ||
        request_state === "annulée" ||
        request_state === "non conforme" ? (
        <Button variant="contained" className="status_deny">
          {request_state}
        </Button>
      ) : request_state === "sous réserve de validation" ? (
        <Button variant="contained" className="status_waiting">
          {request_state}
        </Button>
      ) : (
        <Button variant="contained" className="status_success">
          {request_state}
        </Button>
      )}
    </>
  );
}

function validation_state(validation_state) {
  return (
    <>
      {
        validation_state === 0
          ? <Button variant="contained" className="status_deny">{"refus de validation"}</Button>
          : validation_state === null
            ? <Button variant="contained" className="status_waiting">{"en cours de validation"}</Button>
            : <Button variant="contained" className="status_success">{"validé"}</Button>
      }
    </>

  );
}

function return_validation_state(validation_state) {
  return (
    validation_state === 0
      ? "refus de validation"
      : validation_state === null
        ? "en cours de validation"
        : "validée"
  );
}


function Order_detail({
  order_key,
  title,
  order_number,
  id_supplier,
  request_code,
  supplier,
  details,
  inner_state,
  products_bysupplier,
  setProducts_bysupplier,
  well_received,
  order_conforme,
  order_no_conforme,
  able_to_process_order
}) {
  const [open_reason_modal, setOpen_reason_modal] = useState(null);

  function download_order_details_file(e, request_code, order_infos) {
    e.stopPropagation();
    let request_code_tmp_array = request_code.split(" - ");
    const formData = new FormData();
    formData.append("order_id", order_infos.order_id);
    formData.append("request_code", request_code);
    download_order_file(formData).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      let file_extension = "";
      const disposition = response.headers["content-disposition"];
      if (disposition && disposition.includes("filename")) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          file_extension = matches[1].replace(/['"]/g, "").split(".")[1];
        }
      }
      fileLink.setAttribute(
        "download",
        request_code_tmp_array[0] +
        "_" +
        request_code_tmp_array[1] +
        "_" +
        order_infos.order_id +
        "." +
        file_extension
      );
      document.body.appendChild(fileLink);
      fileLink.click();
    }).catch((error) => {
     //  console.log(error.response);
    });
  }

  return (
    <div>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <div className="order_accordion_header">
              <div className="accordion_header_content">
                <span>{title}</span>
                <span className="supplier_infos">{supplier.substring(0, supplier.lastIndexOf("--")).trim()}</span>
              </div>
              <div className="accordion_header_actions">
                {
                /* <div className="action_button_container">
                  {details.order_state !== "annulée" &&
                  details.order_state !== "conforme" ? (
                    <>
                      {details.order_state !== "bien reçu" ? (
                        <Tooltip title="la commande est reçue" placement="top">
                          <span
                            style={{ color: "rgb(228, 88, 32)" }}
                            className={
                              details.order_state === "en cours de livraison"
                                ? "my_icon checkIcon"
                                : "my_icon checkIcon disabled_button"
                            }
                          >
                            <DoneIcon
                              style={{ cursor: "pointer" }}
                              onClick={(e) =>
                                well_received(
                                  e,
                                  id_supplier,
                                  request_code,
                                  order_key
                                )
                              }
                            />
                          </span>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip
                            title="Commande non conforme"
                            placement="top"
                          >
                            <span
                              style={{ color: "#e92a44", marginRight: "4px" }}
                              onClick={(e) =>
                                order_no_conforme(
                                  e,
                                  id_supplier,
                                  request_code,
                                  order_key
                                )
                              }
                            >
                              <RemoveDoneIcon
                                style={{ cursor: "pointer" }}
                                className="my_icon closeSharpIcon"
                              />
                            </span>
                          </Tooltip>
                          <Tooltip title="Commande conforme" placement="top">
                            <span
                              style={{ color: "#18ac67" }}
                              onClick={(e) =>
                                order_conforme(
                                  e,
                                  id_supplier,
                                  request_code,
                                  order_key
                                )
                              }
                            >
                              <DoneAllIcon
                                style={{ cursor: "pointer" }}
                                className="my_icon checkIcon"
                              />
                            </span>
                          </Tooltip>
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </div> */}
                <div className="request_state_container">
                  <>
                    {
                      able_to_process_order == true || ["annulée"].includes(details.order_state)
                        ? <>
                          {state(details.order_state)}
                          <>
                            {["sous réserve de validation", "refusée", "refus de validation", "annulée", "non conforme"].includes(details.order_state) && (
                              <span
                                className='view_reason_button'
                                onClick={(e) => {
                                  e.stopPropagation();

                                  // Determine the reason to show
                                  let reason = details.service_refuse_reason
                                    ? details.service_refuse_reason
                                    : details.refuse_reason;

                                  // If non_conformity_reason exists, use it as well
                                  if (inner_state?.non_conformity_reason) {
                                    reason = inner_state.non_conformity_reason;
                                  }

                                  setOpen_reason_modal(reason);
                                }}
                              >
                                Motif
                              </span>
                            )}
                          </>
                        </>
                        : <>{validation_state(null)}</>
                    }
                  </>
                </div>
                {/* <span style={{ display: "flex" }}>
                  <Tooltip title="Exporter en fichier pdf" placement="bottom">
                    <span style={{ marginLeft: "9px" }}>
                      <Fab
                        size="small"
                        onClick={(e) =>
                          download_order_details_file(
                            e,
                            request_code,
                            details
                          )
                        }
                        color="default"
                        style={{ backgroundColor: "#efefef" }}
                        className={
                          details.order_state != null &&
                            details.order_state !== "annulée" &&
                            details.order_state !== "refusée" &&
                            details.order_state !== "refus de validation" &&
                            details.order_state !== "sous réserve de validation"
                            ? "round_button"
                            : "round_button disabled_button"
                        }
                      >
                        <GetAppRoundedIcon className="my_icon" />
                      </Fab>
                    </span>
                  </Tooltip>
                </span> */}
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <Order_details_modal
              selected_products_details={details}
              request_code={request_code}
              products_bysupplier={products_bysupplier}
              id_supplier={id_supplier}
              setProducts_bysupplier={setProducts_bysupplier}
              order_key={order_key}
              order_number={order_number}
            />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      {open_reason_modal !== null ? (
        <View_refuse_reason
          open_reason_modal={open_reason_modal}
          setOpen_reason_modal={setOpen_reason_modal}
        />
      ) : (
        <></>
      )}
    </div>
  );
}


function Request_details({ request_code, setRequest_code, request_details, setRequest_details }) {

  const [products_bysupplier, setProducts_bysupplier] = useState(null);
  const [details, setDetails] = useState(null);
  const [inner_state, setInner_state] = useState([]);
  const [wait_submitting, setWait_submitting] = useState(false);
  const [open_reason_modal, setOpen_reason_modal] = useState(null);
  const [order_key, setorder_key] = useState(null);
  const [stockStatus, setStockStatus] = useState(null);
  const [tmpStockProcessing, setTmpStockProcessing] = useState(null);

  const [request_validation_processes, setRequest_validation_processes] = useState([]);
  const [view_validation_history, setview_validation_history] = useState(null);

  const classes = useStyles();


  async function get_replacement(tmp_products_bysupplier, replaced_by, selected_products_tmp_array) {
    var replaced_by_tmp = replaced_by;
    let replaced_by_array = replaced_by_tmp.split(",");
    var mergedObject = {};
    for (let i in replaced_by_array) {
      if (replaced_by_array[parseInt(i)] !== "") {
        let formData = new FormData();
        formData.append("products_codes", JSON.stringify(selected_products_tmp_array));
        formData.append("request_code", request_code);
        formData.append('replaced_by', parseInt(replaced_by_array[parseInt(i)]));
        mergedObject = await get_order_productsInfos(formData).then(
          (response) => {
            let data = response.data;
            for (const id_supplier_name in data) {
              tmp_products_bysupplier[id_supplier_name] =
                response.data[id_supplier_name];
              tmp_products_bysupplier[id_supplier_name]["replaced_by"] =
                response.data[id_supplier_name].replaced_by
                  ? response.data[id_supplier_name].replaced_by
                  : "";
              tmp_products_bysupplier[id_supplier_name]["order_state"] =
                response.data[id_supplier_name].order_state;
              tmp_products_bysupplier[id_supplier_name]["service_accord"] =
                response.data[id_supplier_name].service_accord;
              tmp_products_bysupplier[id_supplier_name]["products"] =
                data[id_supplier_name].products;
              if (response.data[id_supplier_name].replaced_by)
                get_replacement(
                  tmp_products_bysupplier,
                  replaced_by,
                  selected_products_tmp_array
                );
            }
            return tmp_products_bysupplier;
          }
        );
      }
    }
    return mergedObject;
  }

  useEffect(() => {
    setDetails(null);
    setProducts_bysupplier(null);

    async function get_orders_products(orders, request_code) {
      var tmp_products_bysupplier = {};
      var mergedObject = {};
      for (const id_supplier in orders) {
        let selected_products = orders[id_supplier];
        let selected_products_tmp_array = [];
        selected_products.map((selected_product) => {
          selected_products_tmp_array.push(selected_product.product_code);
        });
        //console.log(selected_products_tmp_array);

        let formData = new FormData();
        formData.append("products_codes", JSON.stringify(selected_products_tmp_array));
        formData.append("request_code", request_code);
        formData.append("id_supplier", id_supplier);
       //  console.log(request_code, id_supplier);
        var tmp_add_products_bysupplier = {};
        var selected_products_details_tmp_array = [];
        mergedObject = await get_order_productsInfos(formData)
          .then(async (response) => {
            let data = response.data;
            //console.log(data);
            for (const id_supplier_name in data) {
              data[id_supplier_name].products.map((element, id) => {
                selected_products.map((selected_product, id) => {
                  if (selected_product.product_code === element.product_code) {
                    element.product_amount = element.product_amount
                      ? element.product_amount
                      : selected_product.product_amount;
                  }
                });
                selected_products_details_tmp_array.push(element);
              });
              tmp_products_bysupplier[id_supplier_name] = response.data[id_supplier_name];
              tmp_products_bysupplier[id_supplier_name]["replaced_by"] = response.data[id_supplier_name].replaced_by ? response.data[id_supplier_name].replaced_by : "";
              tmp_products_bysupplier[id_supplier_name]["order_state"] = response.data[id_supplier_name].order_state;
              tmp_products_bysupplier[id_supplier_name]["order_id"] = response.data[id_supplier_name].order_id;
              tmp_products_bysupplier[id_supplier_name]["service_accord"] = response.data[id_supplier_name].service_accord;
              tmp_products_bysupplier[id_supplier_name]["products"] = selected_products_details_tmp_array;

              const replacemment = await get_replacement(tmp_products_bysupplier, tmp_products_bysupplier[id_supplier_name]["replaced_by"], selected_products_tmp_array);
              if (replacemment && Object.keys(replacemment).length) {
                mergedObject = {
                  ...mergedObject,
                  ...replacemment,
                };
              } else {
                mergedObject = {
                  ...mergedObject,
                  ...tmp_products_bysupplier,
                };
              }
              return mergedObject;
            }
          })
          .catch((error) => {
            //console.log(error.response);
          });
        //console.log(mergedObject);
      }
      setProducts_bysupplier(mergedObject);
    }

    async function load_data() {
      const formData = new FormData();
      formData.append("request_code", request_code);
      await get_applicant_request_details(formData)
        .then((response) => {
         //  console.log(response.data);
          const fetchedDetails = {
            ...request_details,
            ...response.data
          };
         //  console.log("fetchedDetails", fetchedDetails);
          setDetails(fetchedDetails);
          const suppliers = response.data.selected_suppliers;

          ////  console.log("$$$$$$$$$$$$$$$$$$",response.data);
          {
            suppliers.map((supplier, index) => {
              let innerState = {};
              try {
                innerState = JSON.parse(supplier.inner_state); // Convert string to object
                setInner_state(innerState);
              } catch (error) {
                console.error("Error parsing inner_state:", error);
              }
              return null; // This ensures the map doesn't break but isn't rendering anything
            })
          }

          //  Immediately handle stock processing
          if (fetchedDetails?.stock_processing) {
            const parsedStockProcessing = JSON.parse(
              fetchedDetails.stock_processing
            );
            setTmpStockProcessing(parsedStockProcessing);
            setStockStatus(parsedStockProcessing?.status ?? null);
          } else {
            setTmpStockProcessing(null);
            setStockStatus(null);
          }
          get_orders_products(JSON.parse(response.data.products), request_code);
        })
        .catch((error) => {
         //  console.log(error.response);
        });

      await check_weither_ispossible_to_proceed(formData).then((response) => {
       //  console.log("check_weither_ispossible_to_proceed : ", response.data);
        setRequest_validation_processes(response.data);
      }).catch((error) => {
       //  console.log(error.response);
      })
    }


    load_data();
  }, [request_code]);


  function get_request_validation_hist(validation_processes) {
    let order_validation_process = validation_processes.filter((proc) => proc.request_order_id == 0);
    return order_validation_process;
  }


  function verify_request_order_validation(validation_processes, order_id) {
    let order_validation_process = validation_processes.filter((step) => step.request_order_id == order_id).sort((a, b) => (new Date(b.created_at) - new Date(a.created_at)));
    let able_to_proceed = true;
    let users_id = [];
    for (let step of order_validation_process) {
      if (!users_id.includes(step.user) && step.validated == 1) users_id.push(step.user);
      if (step.validated != 1 && !users_id.includes(step.user)) {
        able_to_proceed = false;
        users_id.push(step.user);
        break;
      }
    }
    //console.log("validation process : ", order_validation_process, users_id, able_to_proceed);
    return able_to_proceed;
  }

  function get_order_number(data, id) {
    if (id === 0) {
      return id + 1;
    } else {
      if (products_bysupplier[data[id - 1]].replaced_by !== "") {
        return id;
      } else {
        let max_id = 1;
        for (let j = 0; j < id; j++) {
          max_id = Math.max(max_id, get_order_number(data, j));
        }
        return max_id + 1;
      }
    }
  }
  //
  function well_received(e, id_supplier, request_code, key) {
    e.stopPropagation();
    swal({
      title: "Etes-vous sûr ?",
      text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setWait_submitting(true);
        let formData = new FormData();
        formData.append("id_supplier", id_supplier);
        formData.append("request_code", request_code);
        formData.append("state", "bien reçu");
        requester_change_order_state(formData)
          .then((response) => {
            //console.log(response.data);
            let tmp_json = { ...products_bysupplier };
            tmp_json[key].order_state = "bien reçu";
            setProducts_bysupplier(tmp_json);
            setWait_submitting(false);
            swal(
              "votre réponse a été enregistrée avec succès et le service sera bientôt notifié !",
              {
                icon: "success",
              }
            );
          })
          .catch((error) => {
            //console.log(error.response);
            setWait_submitting(false);
          });
      }
    });
  }
  //conform
  function order_conforme(e, id_supplier, request_code, key) {
    e.stopPropagation();
    swal({
      title: "Etes-vous sûr ?",
      text: "Une fois que vous avez soumis votre réponse, vous ne pourrez plus la modifier !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        setWait_submitting(true);
        let formData = new FormData();
        formData.append("id_supplier", id_supplier);
        formData.append("request_code", request_code);
        formData.append("state", "conforme");
        requester_change_order_state(formData)
          .then((response) => {
            //console.log(response.data);
            let tmp_json = { ...products_bysupplier };
            tmp_json[key].order_state = "conforme";
            setProducts_bysupplier(tmp_json);
            setWait_submitting(false);
            swal(
              "votre réponse a été enregistrée avec succès et le fournisseur sera bientôt notifié !",
              {
                icon: "success",
              }
            );
          })
          .catch((error) => {
            //console.log(error.response);
            setWait_submitting(false);
          });
      }
    });
  }

  function order_no_conforme(e, id_supplier, request_code, key) {
    e.stopPropagation();
    let formData = new FormData();
    formData.append("id_supplier", id_supplier);
    formData.append("request_code", request_code);
    formData.append("state", "non conforme");
    setOpen_reason_modal(formData);
    setorder_key(key);
  }

  function validate_request_orders(request_code, validated) {
    let formData = new FormData();
    formData.append('token', details.token);
    formData.append('validated', validated);
    formData.append('state', return_validation_state(validated));
    formData.append("request_code", request_code);
    setOpen_reason_modal(formData);
  }

  return (
    <Dialog
      disableEnforceFocus
      fullScreen
      open={request_code ? true : false}
      onClose={() => { setRequest_code(null); setRequest_details(null) }}
      className="my_full_dialog contract_full_dialog"
    >
      <AppBar className={classes.appBar}>
        <Toolbar style={{ backgroundColor: "#343a40" }}>
          <div className="page_title">
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => { setRequest_code(null); setRequest_details(null) }}
              aria-label="close"
            >
              <CloseIcon className="my_icon" />
            </IconButton>
            <span> Details de la demande : {request_code} </span>
            <div className='request_state_container'>
              {details!=null?validation_state(details.validated):""}
            </div>
            <>
              {<span
                className='view_reason_button' style={{ margin: "0", marginLeft: "8px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  setview_validation_history(get_request_validation_hist(request_validation_processes))
                }}
              >(Historique)</span>
              }
            </>
          </div>
          {
            details !== null && (details.validated != 1)
              ? <div className="request_order_toolbar_right">
                <Tooltip title="Refuser de valider" placement="bottom" >
                  <span>
                    <Button className={!wait_submitting ? "submit_but notify_requester_button cancel_but" : "submit_but notify_requester_button cancel_but disabled_button"}
                      onClick={() => validate_request_orders(request_code, 0)}>
                      Refuser
                    </Button>
                  </span>
                </Tooltip>
                <Tooltip title="Valider" placement="bottom" >
                  <span>
                    <Button className={!wait_submitting ? "submit_but notify_requester_button valide_but" : "submit_but notify_requester_button valide_but disabled_button"}
                      onClick={() => validate_request_orders(request_code, 1)}>
                      Accepter
                    </Button>
                  </span>
                </Tooltip>
              </div>
              : <></>
          }
        </Toolbar>
      </AppBar>

      {details !== null && products_bysupplier !== null ? (
        <div className="requester_requests_details_container request_details_container">
          <Request_detail title="Détails" details={details} />

          {stockStatus ? (
            <InnerStockDetails
              tmp_stock_processing={tmpStockProcessing}
              stockStatus={stockStatus}
              setStockStatus={setStockStatus}
              request_details={details}
              request_code={request_code}
            />
          ) : null}

          <>
            {Object.keys(products_bysupplier).length !== 0 ? (
              <>
                {Object.keys(products_bysupplier).map((key, id) => (
                  <Order_detail
                    key={key}
                    order_key={key}
                    title={
                      "Commande " +
                      get_order_number(Object.keys(products_bysupplier), id) +
                      " / "
                    }
                    order_number={get_order_number(
                      Object.keys(products_bysupplier),
                      id
                    )}
                    id_supplier={key.split("*")[0]}
                    supplier={key.split("*")[1]}
                    request_code={request_code}
                    details={products_bysupplier[key]}
                    inner_state={inner_state}
                    products_bysupplier={products_bysupplier}
                    able_to_process_order={verify_request_order_validation(request_validation_processes, products_bysupplier[key].order_id)}
                    setProducts_bysupplier={setProducts_bysupplier}
                    well_received={well_received}
                    order_conforme={order_conforme}
                    order_no_conforme={order_no_conforme}
                  />
                ))}
              </>
            ) : (
              <></>
            )}
          </>
        </div>
      ) : (
        <Loading_animation_view />
      )}

      {
        view_validation_history != null
          ? <Validation_history view_validation_history={view_validation_history} setview_validation_history={setview_validation_history} request_history={request_code} />
          : <></>
      }

      {open_reason_modal !== null ? (
        <>
          <Set_comment
            open_reason_modal={open_reason_modal}
            setOpen_reason_modal={setOpen_reason_modal}
            details={details}
            setDetails={setDetails}
          />
        </>
      ) : (
        <></>
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={wait_submitting}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Dialog>
  );
}

export default Request_details;
